var Donnees_Personnelles = {
	init:function(){
		Debug.log("INIT DONNEES PERSONNELLES");
		Accordeon.clickOn($(".donnees-personnelles .donnees-container").find(".item:first-child"));
	}
}
$(window).load(function(){
	if($(".donnees-personnelles").length){
		Donnees_Personnelles.init();
	}
})